// Module
var code = " <gh-page layout=\"catalog\"> <gh-page-header icon=\"gh:setup\" parentTitle=\"{{'lbl_setup' | translate}}\" pageTitle=\"{{'lbl_menu_office_users' | translate}}\"> </gh-page-header> <gh-page-content> <gh-office-user-list-tab class=\"flex-1 flex-column\"></gh-office-user-list-tab> </gh-page-content> </gh-page> ";
// Exports
module.exports = code;